module.exports = __webpack_public_path__ + "static/img/UTM老师_火花.914eae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_火花.png
// module id = NgTK
// module chunks = 0